$(document).ready(function(){

	$('.js-find-a-mentor').on('click', function(e){
		e.preventDefault();

		$('html,body').animate({
			scrollTop: $('.intro').offset().top - 200
		},'slow');
	});


	$('.js-request-a-mentorship').on('click', function(e){
		e.preventDefault();

		let mentor = $(this).parents('.mentor').data('mentor');
		console.log(mentor);

		$('.c-form select').val(mentor).change();

		$('#modal').modal({
	    	fadeDuration: 250
	  });
	})

	$('.js-become-a-mentor').on('click', function(e){
		e.preventDefault();

		$('#modal2').modal({
	    	fadeDuration: 250
	  });
	})

	$(".card").on('click', function(e){
		let mentor = $(this).data('mentor');
		$('html,body').animate({
			scrollTop: $('.mentor[data-mentor="'+ mentor +'"]').offset().top - 200
		},'slow');
	});

})
